import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function ProtectedRoute({ children, adminOnly = true }) {
  const [state, setState] = useState({ status: "checking", user: null });

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me", { withCredentials: true })
      .then((r) => {
        if (adminOnly && !r.data.is_admin) setState({ status: "forbidden", user: r.data });
        else setState({ status: "ok", user: r.data });
      })
      .catch(() => setState({ status: "unauth", user: null }));
  }, [adminOnly]);

  if (state.status === "checking")
    return <div className="bb-container py-20 text-center bb-overline text-bb-slate">Verifying access…</div>;
  if (state.status === "unauth") return <Navigate to="/login" replace />;
  if (state.status === "forbidden")
    return (
      <div className="bb-container py-20" data-testid="forbidden">
        <div className="max-w-md mx-auto border border-border bg-white p-8 text-center">
          <div className="bb-overline text-bb-copper">403 · Not authorized</div>
          <h1 className="font-archivo text-2xl text-bb-navy font-bold mt-3">You&rsquo;re signed in but not on the editor allowlist.</h1>
          <p className="text-sm text-bb-slate mt-3">Contact the site admin to be added.</p>
        </div>
      </div>
    );
  return children;
}
